import { Component, Input, OnInit } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { RecurrableSession } from '@models/instructor-led';
import { TranslateService } from '@ngx-translate/core';
import { IlSession } from '@queries/generated';
import { PluralTranslateService } from '@services/plural-translate.service';
import { days, diffDate } from '@util/date';

@Component({
  selector: 'vnm-session-date',
  templateUrl: './session-date.component.html',
  styleUrls: ['./session-date.component.scss']
})
export class SessionDateComponent implements OnInit {
  private localTz = new Date().toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop();

  @Input() session: RecurrableSession;
  @Input() firstSession: IlSession;
  @Input() relativeScheduling = false;
  @Input() dateIcon: IconProp = 'calendar-alt';
  @Input() timeIcon: IconProp = 'clock';
  @Input() showSessionTz = false;

  daysAfterLabel: string;

  get timeZone() {
    if (this.showSessionTz) {
      return this.session?.timeZone;
    } else {
      return this.localTz;
    }
  }

  constructor(private translateService: TranslateService, private pluralTranslateService: PluralTranslateService) {}

  ngOnInit() {
    if (this.firstSession && this.firstSession === this.session) {
      this.daysAfterLabel = this.translateService.instant('session-date.first-session');
    } else if (this.firstSession) {
      const days = this.session.daysAfterFirstSession || this.daysAfterFirstSession();
      this.daysAfterLabel = this.pluralTranslateService.instant('session-date.subsequent-session', days, { days });
    }
  }

  daysAfterFirstSession(): number {
    return days(diffDate(this.session.startsAt, this.firstSession.startsAt));
  }
}
